/**
 * Branded Text Wrapper
 * Prevents specified phrases from breaking across lines in specific sections
 * Only runs on the homepage (index template)
 */

(function () {
  // Configuration: Map section identifiers to phrases that should not break
  const BRANDED_TEXT_CONFIG = {
    // By section ID
    '176316682424fdeb2a': ['Native Scripture', 'Book of Mormon'],
    'featured_collection_Aw7qRP': ['The Dual Language', 'Book of Mormon'],
    'image_with_text_93KELm': ['The Dual Language', 'Book of Mormon'],

    // By section name (alternative identifier)
    'Reviews Carosel': ['Native Scripture', 'Book of Mormon'],
    'Featured Collection': ['The Dual Language', 'Book of Mormon'],

    // You can add more sections here
    // 'section_id_or_name': ['Phrase 1', 'Phrase 2']
  };

  /**
   * Wraps specified phrases in a span with no-break class
   */
  function wrapPhrases(element, phrases) {
    if (!element || !phrases || phrases.length === 0) return;

    let html = element.innerHTML;
    let modified = false;

    phrases.forEach(phrase => {
      // Create regex to match the phrase (case-insensitive, whole word)
      const regex = new RegExp(`(${phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      if (regex.test(html)) {
        html = html.replace(regex, '<span class="no-break">$1</span>');
        modified = true;
      }
    });

    if (modified) {
      element.innerHTML = html;
    }
  }

  /**
   * Finds and processes a section by ID or name
   */
  function processSection(sectionId, phrases) {
    let section = null;

    // Try multiple strategies to find the section
    // Strategy 1: Find by shopify-section ID (Shopify's default wrapper)
    section = document.querySelector(`section#shopify-section-${sectionId}`);

    // Strategy 2: Find by data-section attribute
    if (!section) {
      section = document.querySelector(`[data-section="${sectionId}"]`);
    }

    // Strategy 3: Find by data-section-id attribute
    if (!section) {
      section = document.querySelector(`[data-section-id="${sectionId}"]`);
    }

    // Strategy 4: Find by class containing section ID
    if (!section) {
      section = document.querySelector(`.shopify-section-${sectionId}, [class*="${sectionId}"]`);
    }

    // Strategy 5: Find by section name - search all sections for matching content
    if (!section) {
      const allSections = document.querySelectorAll('section[id^="shopify-section-"]');
      allSections.forEach(sec => {
        // Check if section has a heading that matches the section name
        const heading = sec.querySelector('h1, h2, h3, [class*="title"], [class*="heading"], .title, .heading');
        if (heading && heading.textContent) {
          const headingText = heading.textContent.toLowerCase();
          if (headingText.includes(sectionId.toLowerCase())) {
            section = sec;
          }
        }
      });
    }

    // Strategy 6: If still not found, search for sections containing any of the phrases
    // This is a fallback for app sections that might not have clear identifiers
    if (!section) {
      const allSections = document.querySelectorAll('section[id^="shopify-section-"]');
      allSections.forEach(sec => {
        const sectionText = sec.textContent || '';
        // Check if this section contains any of our target phrases
        const containsPhrase = phrases.some(phrase =>
          sectionText.includes(phrase)
        );
        if (containsPhrase) {
          // Double-check by looking for headings that might match
          const heading = sec.querySelector('h1, h2, h3, [class*="title"], [class*="heading"]');
          if (heading) {
            section = sec;
          }
        }
      });
    }

    if (!section) {
      console.log(`Branded Text Wrapper: Could not find section "${sectionId}". Available sections:`,
        Array.from(document.querySelectorAll('section[id^="shopify-section-"]')).map(s => s.id));
      return;
    }

    // Find all text elements that might contain the phrases
    const textElements = section.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div[class*="title"], div[class*="heading"], .title, .heading');

    textElements.forEach(element => {
      // Skip if already processed (has no-break spans)
      if (element.querySelector('.no-break')) return;
      wrapPhrases(element, phrases);
    });
  }

  /**
   * Fallback: Process all sections that contain target phrases
   */
  function processAllSections() {
    // console.log('==== PROCESSING ALL SECTIONS ====');
    const allSections = document.querySelectorAll('section[id^="shopify-section-"]');
    const processedSections = new Set();

    // Get all unique phrases from config
    const allPhrases = new Set();
    Object.values(BRANDED_TEXT_CONFIG).forEach(phrases => {
      phrases.forEach(phrase => allPhrases.add(phrase));
    });

    allSections.forEach(section => {
      const sectionText = section.textContent || '';
      const sectionId = section.id;

      // Check if this section contains any of our target phrases
      const matchingPhrases = Array.from(allPhrases).filter(phrase =>
        sectionText.includes(phrase)
      );

      if (matchingPhrases.length > 0 && !processedSections.has(sectionId)) {
        // Find the config entry that matches this section's phrases
        const configEntry = Object.entries(BRANDED_TEXT_CONFIG).find(([id, phrases]) => {
          return phrases.some(p => matchingPhrases.includes(p));
        });

        if (configEntry) {
          const [, phrases] = configEntry;
          const textElements = section.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div[class*="title"], div[class*="heading"], .title, .heading');
          textElements.forEach(element => {
            if (!element.querySelector('.no-break')) {
              wrapPhrases(element, phrases);
            }
          });
          processedSections.add(sectionId);
        }
      }
    });
  }

  /**
   * Main initialization function
   */
  function init() {
    // Only run on homepage (index template)
    const isHomepage = document.body.classList.contains('template-index') ||
      window.location.pathname === '/' ||
      window.location.pathname === '' ||
      window.location.pathname.match(/^\/?$/);

    if (!isHomepage) return;

    // Process each configured section by ID/name
    Object.entries(BRANDED_TEXT_CONFIG).forEach(([sectionId, phrases]) => {
      processSection(sectionId, phrases);
    });

    // Fallback: Process all sections that contain target phrases
    processAllSections();

    // Also add CSS for no-break class if not already present
    if (!document.getElementById('branded-text-wrapper-styles')) {
      const style = document.createElement('style');
      style.id = 'branded-text-wrapper-styles';
      style.textContent = '.no-break { white-space: nowrap; }';
      document.head.appendChild(style);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Retry after a delay for dynamically loaded content (like Judge.me reviews)
  setTimeout(init, 1000);
  setTimeout(init, 3000);
})();

